import { RangeCatalog } from '@inter-ikea-storageone/range';

const rangesInBrygga = [
  'st1-platsa',
  'st1-billy',
  'st1-ladmakare',
  'st1-eket',
  'knoxhult',
  'knobsandhandles',
  'media',
  'kitchen-appliances',
  'kitchen-sinks',
  'kitchen-taps'
];

export const supportsWebp = async () => {
  return new Promise<boolean>(resolve => {
    const image = new Image();
    image.addEventListener('error', () => {
      return resolve(false);
    });
    image.addEventListener('load', () => {
      return resolve(image.width === 1);
    });
    image.src =
      'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
  }).catch(() => {
    return false;
  });
};

let isWebpSupported: boolean | undefined = undefined;
// Checks if the browser supports WEBP.
supportsWebp().then(supports => {
  isWebpSupported = supports;
});

export const getOptimizedModels = (catalog: RangeCatalog) => {
  const products = isWebpSupported
    ? catalog.products.map((product: any) => {
        if (product.modelURI === undefined) {
          return product;
        }
        const modelURI = rangesInBrygga.includes(catalog.range.toLowerCase())
          ? product.modelURI.replace('.glb', '_opt_webp.glb')
          : product.modelURI.replace('.glb', '.optimized.glb');
        return { ...product, modelURI };
      })
    : catalog.products;
  return { ...catalog, products };
};
